import { storerCompressor } from './storerCompressor-sidecar'

export function load(localStorageKey: string, version: number) {
  try {
    let str: string | null = localStorage.getItem(localStorageKey)
    if (str) {
      let idx1 = str.indexOf(':')
      if (idx1 === -1) {
        return null
      }
      let idx2 = str.indexOf(':', idx1 + 1)
      if (idx2 === -1) {
        return null
      }
      let idx3 = str.indexOf(':', idx2 + 1)
      if (idx3 === -1) {
        return null
      }

      let version = str.substring(idx1 + 1, idx2)
      console.log('version', version)
      if (version !== version) {
        return null
      }

      let compression = str.substring(idx2 + 1, idx3)
      console.log('compression', compression)

      let data = str.substring(idx3 + 1)
      let isCompressed = compression === 'lz'
      if (isCompressed) {
        return JSON.parse(storerCompressor.decompress(data))
      } else {
        return JSON.parse(data)
      }
    }
  } catch (err) {
    console.error(
      'failed to load',
      localStorageKey,
      localStorage.getItem(localStorageKey),
    )
  }
}

export function save(
  localStorageKey: string,
  version: number,
  data: any,
  compress = false,
) {
  let str = 'version:' + version + ':' + (compress ? 'lz' : 'raw') + ':'
  if (compress) {
    str += storerCompressor.compress(JSON.stringify(data))
  } else {
    str += JSON.stringify(data)
  }
  localStorage.setItem(localStorageKey, str)
  console.log('saver', localStorageKey, 'wrote', str.length, 'chars')
}

export function deleteKey(localStorageKey: string) {
  localStorage.removeItem(localStorageKey)
}

export function deleteKeysLike(prefix: string) {
  for (let i = 0; i < localStorage.length; i++) {
    let key = localStorage.key(i)
    if (key && key.startsWith(prefix)) {
      deleteKey(key)
    }
  }
}
